import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.salesOrganization || initialState;

export const selectSalesOrganisation = createSelector(
  [selectSlice],
  state => state,
);

export const selectIsAPIComplete = createSelector(
  [selectSlice],
  state => state.isAPIComplete,
);

export const selectStoreId = createSelector(
  [selectSlice],
  state => state.data?.store_id || null,
);
